import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery, useQueryClient } from '@tanstack/react-query';
import getFetchCartOptions from './get-options';
import useIsBuyMarketplaceSupported from "../../../use-is-marketplace-supported";
var useFetchCart = function useFetchCart() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      enabled: true
    },
    select = _ref.select,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    placeholderData = _ref.placeholderData;
  var queryClient = useQueryClient();
  var isMarketplaceSupported = useIsBuyMarketplaceSupported();
  return useQuery(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getFetchCartOptions({
    queryClient: queryClient
  })), select && {
    select: select
  }), placeholderData && {
    placeholderData: placeholderData
  }), {}, {
    enabled: enabled && isMarketplaceSupported
  }));
};
export default useFetchCart;